import { render, staticRenderFns } from "./ProInfoDetail.vue?vue&type=template&id=3a8045bc&"
import script from "./ProInfoDetail.vue?vue&type=script&lang=js&"
export * from "./ProInfoDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProInfoDetail.vue?vue&type=style&index=0&id=3a8045bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports